export default "__VITE_ASSET__D3O8V7DO__"